import React, {createContext, useReducer} from "react";
import {CycleManagementReducer} from "../reducer/CycleManagementReducer";
import {DEFAULT_ALERT, DEFAULT_HOUR, HOUR_OPTIONS} from "../Constants";

export const CycleManagementContext = createContext()

const CycleManagementContextProvider = (props) => {
    const cycleInitialState = {
        cycleConfig : {},
        plannedCycles : {},
        cycleStatus: {},
        cycleTimes : HOUR_OPTIONS,
        childNodes : [],
        alert: DEFAULT_ALERT,
        loadingNode: true,
        loadingCycle: true,
        isNodeEnabled: false,
        selectedNodeId: "",
        selectedCycleId: "",
        selectedTime: DEFAULT_HOUR,
    }
    const [cycleViewModel, cycleDispatch] = useReducer(CycleManagementReducer, cycleInitialState)
    return (
        <CycleManagementContext.Provider value = {{cycleViewModel, cycleDispatch}}>
            {props.children}
        </CycleManagementContext.Provider>
    )
}

export default CycleManagementContextProvider


// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/context/CycleManagementContext.js